module.exports = __webpack_public_path__ + "img/bell_1.6884c9a5.jpg";